/**
 * QuickBooksConnector — QBO OAuth 2.0 adapter.
 * Sync: invoices + customers. Feeds AEGIS margin intel.
 */

import IntegrationService, { isMockMode } from '../IntegrationService';
import DataService from '../DataService';

const ENV_KEY = 'QBO_API_KEY';

export const QBO_FIELD_PRESETS = [
  { sourceField: 'DocNumber', kairosField: 'invoices.invoiceNumber' },
  { sourceField: 'TotalAmt', kairosField: 'invoices.amount' },
  { sourceField: 'Balance', kairosField: 'invoices.balance' },
  { sourceField: 'DueDate', kairosField: 'invoices.dueAt' },
  { sourceField: 'CustomerRef.name', kairosField: 'customers.name' },
];

const MOCK_INVOICES = [
  { invoiceNumber: 'QBO-INV-7201', customerName: 'Pacific Fresh Foods', amount: 8425, issuedAt: '2026-04-03T00:00:00Z', dueAt: '2026-05-03T00:00:00Z', status: 'open', balance: 8425 },
  { invoiceNumber: 'QBO-INV-7202', customerName: 'Apex Industrial Supply', amount: 12480, issuedAt: '2026-04-05T00:00:00Z', dueAt: '2026-05-05T00:00:00Z', status: 'open', balance: 12480 },
  { invoiceNumber: 'QBO-INV-7203', customerName: 'Summit Building Supply', amount: 5200, issuedAt: '2026-04-08T00:00:00Z', dueAt: '2026-05-08T00:00:00Z', status: 'paid', balance: 0 },
  { invoiceNumber: 'QBO-INV-7204', customerName: 'Heartland Grain Co.', amount: 15680, issuedAt: '2026-04-10T00:00:00Z', dueAt: '2026-05-10T00:00:00Z', status: 'open', balance: 9000 },
  { invoiceNumber: 'QBO-INV-7205', customerName: 'Meridian Manufacturing', amount: 22400, issuedAt: '2026-04-12T00:00:00Z', dueAt: '2026-05-12T00:00:00Z', status: 'overdue', balance: 22400 },
  { invoiceNumber: 'QBO-INV-7206', customerName: 'Coastal Pharma Distribution', amount: 3825, issuedAt: '2026-04-15T00:00:00Z', dueAt: '2026-05-15T00:00:00Z', status: 'open', balance: 3825 },
];

async function sync(connector) {
  const mock = isMockMode(ENV_KEY);
  let created = 0;
  for (const inv of MOCK_INVOICES) {
    await DataService.create('invoices', {
      ...inv,
      tenantId: connector.tenantId,
      syncedFromConnectorId: connector.id,
      syncedAt: new Date().toISOString(),
      source: 'qbo',
    }, 'qbo_sync', 'qbo');
    created++;
  }
  return {
    recordsIn: created,
    recordsOut: 0,
    errors: 0,
    status: 'success',
    summary: mock ? `Mock QBO sync — ${created} invoices → AEGIS margin` : `QBO sync — ${created} invoices`,
  };
}

async function healthCheck() {
  if (isMockMode(ENV_KEY)) return { health: 'green', error: null };
  return { health: 'yellow', error: 'Live QBO health check not yet implemented' };
}

IntegrationService.register('qbo', {
  label: 'QuickBooks Online',
  category: 'financial',
  description: 'Invoices + customers — feeds AEGIS margin intelligence',
  icon: '💵',
  envKey: ENV_KEY,
  setupComponent: 'QBOSetup',
  defaultInterval: 30,
  directions: ['inbound'],
  capabilities: ['invoices_sync', 'customers_sync'],
  sync,
  healthCheck,
});

export default { connectorType: 'qbo', PRESETS: QBO_FIELD_PRESETS };
